/** Shared markers for custom panels injected by the web/mobile shells. */
export const CUSTOM_PANEL_MARKER_ATTR = "data-sfe-custom-panel";
export const NATIVE_PANEL_ATTR = "data-sfe-native-panel";

export function hidePanel(panel: HTMLElement): void {
  panel.setAttribute(NATIVE_PANEL_ATTR, "");
  panel.hidden = true;
}

export function showPanel(panel: HTMLElement): void {
  panel.hidden = false;
  panel.removeAttribute(NATIVE_PANEL_ATTR);
}
